import React, { useEffect, useRef, useState } from 'react';
import { Stack } from '../Stack';
import { ShimmerLoader } from '../ShimmerLoader';
import { NoChangeHistoryMessage } from './NoChangeHistoryMessage';
import { OrderChangeHistoryCard } from './OrderChangeHistoryCard';
import { PrimaryButton } from '../Button/Primary';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const OrderChangeHistoryListWithLoadMore = _ref => {
  let {
    isLoading,
    onLoadMore,
    historyItems,
    areAllItemsLoaded,
    createUpdatedByText,
    listHeight = 'calc(100vh - 70px)'
  } = _ref;
  const loadMoreButtonHeightInPx = 42;
  const loadMoreButtonPaddingBottomInPx = 15;
  const renderHistoryCard = item => /*#__PURE__*/_jsx(OrderChangeHistoryCard, {
    item: item,
    createUpdatedByText: createUpdatedByText
  }, "history-entry-".concat(item.UpdateDate, "-").concat(item.ChangeType));
  const scrollRef = useRef(null);
  const [isFirstPage, setIsFirstPage] = useState(true);
  const loadMore = () => {
    onLoadMore();
    setIsFirstPage(false);
  };
  const scrollToBottom = () => {
    const element = scrollRef.current;
    if (!element) return;
    setTimeout(() => {
      element.scroll({
        top: element.scrollHeight,
        behavior: 'smooth'
      });
    }, 100);
  };
  useEffect(() => {
    if (!isFirstPage && !isLoading) scrollToBottom();
  }, [isFirstPage, isLoading]);
  return /*#__PURE__*/_jsxs(Stack, {
    styles: {
      root: {
        height: '100%',
        justifyContent: 'space-between'
      }
    },
    children: [/*#__PURE__*/_jsx(ShimmerLoader, {
      isLoading: isLoading,
      isBlocking: true,
      children: /*#__PURE__*/_jsxs("div", {
        style: {
          overflow: 'auto',
          height: "calc(".concat(listHeight, " - ").concat(loadMoreButtonHeightInPx, "px - ").concat(loadMoreButtonPaddingBottomInPx, "px)")
        },
        ref: scrollRef,
        id: 'scroll',
        children: [!historyItems.length && /*#__PURE__*/_jsx(NoChangeHistoryMessage, {}), historyItems.map(renderHistoryCard)]
      })
    }), /*#__PURE__*/_jsx(Stack, {
      styles: {
        root: {
          paddingBottom: loadMoreButtonPaddingBottomInPx
        }
      },
      children: /*#__PURE__*/_jsx(PrimaryButton, {
        "data-id": 'load-more-notifications-button',
        styles: {
          root: {
            marginTop: 10,
            width: 120,
            alignSelf: 'center'
          }
        },
        text: 'Load more',
        disabled: areAllItemsLoaded || isLoading,
        onClick: loadMore
      })
    })]
  });
};